export default "__VITE_ASSET__AQgUpGpa__"